import ApiService from "../Services/ApiService";

export interface EligibleTeachr {
    id: number;
    firstName: string;
    lastName: string;
    mail: string;
    brand: string | null;
}

export interface BulkMailPayload {
    subject: string;
    body: string;
    recipientMode: "all" | "selection";
    teachrIds?: number[];
}

export interface BulkMailResult {
    success: boolean;
    sentCount: number;
    recipients: Array<{ id: number; mail: string }>;
    message?: string;
}

/**
 * Envoi de mails groupés aux professeurs éligibles depuis le dashboard admin.
 * L'éligibilité (AE validé, SAP signé, cours déclaré sur 6 mois) est
 * recalculée côté backend à chaque appel.
 */
export default abstract class AdminMailRepository {
    public static getEligibleTeachrs(): Promise<{ count: number; teachrs: EligibleTeachr[] }> {
        return ApiService.get(`/admin/teachrs/mail/eligible`);
    }

    public static sendBulkMail(payload: BulkMailPayload): Promise<BulkMailResult> {
        return ApiService.post(`/admin/teachrs/mail/send`, payload) as Promise<BulkMailResult>;
    }
}
